function tasksReducer(tasks, action) {
    switch (action.type) {
      case 'added': {
        return [...tasks, {
          id: action.id,
          text: action.text,
          done: false
        }];
      }
      case 'changed': {
        return tasks.map(t => {
          if (t.id === action.task.id) {
            console.log(action);
            return { ...action.task };
          } else {
            return t;
          }
        });
      }
      case 'deleted': {
        return tasks.filter(t => t.id !== action.id);
      }
      case 'remove_done': {
        return tasks.filter(t => !t.done);
      }
      case 'clear': {
        return [];
      }
      default: {
        throw Error('Unknown action: ' + action.type);
      }
    }
  };

  export default tasksReducer;